<template>
    <section id="not-enough-tokens-modal"
        class="not-enough-tokens-modal"
    >
        <img :src="require('@webapp/assets/sendout-limit.webp')"
            class="not-enough-tokens-modal__image"
        >

        <div id="not-enough-tokens-modal-title"
            class="not-enough-tokens-modal__title"
        >
            {{ modal.data.text }}
        </div>
        <div id="not-enough-tokens-modal-message"
            class="not-enough-tokens-modal__message"
        >
            {{ modal.data.message }}
        </div>

        <div class="not-enough-tokens-modal__table">
            <div id="not-enough-tokens-modal-amount-needed"
                class="not-enough-tokens-modal__row"
            >
                {{ $t('marketplace.tokenBalance.amountNeeded') }}

                <div class="not-enough-tokens-modal__amount">
                    {{ amountNeeded }}
                </div>
            </div>
        </div>

        <div class="buttons">
            <div id="not-enough-tokens-modal-button"
                class="buttons__item buttons__item--success"
                @click="doAction"
            >
                {{ $t('marketplace.buyFanTokens') }}
            </div>
        </div>
    </section>
</template>

<script>
// 3rd Party
import {
    mapActions,
    mapGetters,
} from 'vuex';

// Utils
import {
    formatNumber,
} from '@shared/utils/formatter.js';

// Local store
import localStoreTypes from '@webapp/store/types.js';

export default {
    name: 'not-enough-amount-modal',
    computed: {
        ...mapGetters(['modal']),

        amountNeeded() {
            return `${formatNumber(this.amount)} ${this.shortName}`;
        },
        amount() {
            return this.modal.data && this.modal.data.amount
                ? this.modal.data.amount
                : 0;
        },
        shortName() {
            return this.modal.data && this.modal.data.symbol
                ? this.modal.data.symbol
                : '';
        },
    },
    methods: {
        ...mapActions({
            resetModal: localStoreTypes.RESET_MODAL,
        }),
        doAction() {
            if (this.modal.data.action instanceof Function) {
                this.modal.data.action();
                this.resetModal();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.not-enough-tokens-modal {
    display: -webkit-box;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: $cyprus-color;

    &__image {
        max-width: 28rem;

        @include max-width(sm) {
            max-width: 20rem;
        }
    }

    &__title {
        padding: 2rem 0;
        font-size: 2.4rem;
        white-space: pre-line;
        font-weight: 700;

        @include max-width(sm) {
            font-size: 1.4rem;
        }
    }

    &__message {
        padding-bottom: 2rem;
        font-size: 1.4rem;
        font-weight: 400;
    }

    &__table {
        width: 33.8rem;
        border-top: 0.1rem solid $alto-color;

        @include max-width(sm) {
            width: 100%;
            margin: 2rem 0;
        }
    }

    &__row {
        display: flex;
        justify-content: space-between;
        padding: 2rem 0 4rem 0;
        font-size: 1.5rem;
        line-height: 2rem;
        font-weight: 600;

        @include max-width(sm) {
            font-size: 1.4rem;
        }
    }

    &__amount {
        text-align: right;

        span {
            font-size: 1.5rem;
            line-height: 2rem;
            font-weight: 600;
            display: block;
        }
    }
}

.buttons {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin: 0 0 2rem;
    width: 100%;

    &__item {
        text-align: center;
        font-size: 1.4rem;
        font-weight: 600;
        width: 34rem;
        margin: 2rem 0 0;
        cursor: pointer;

        @include max-width(sm) {
            width: 25rem;
        }

        &--success {
            margin-top: 0;
            line-height: 4rem;
            border-radius: 0.4rem;
            color: $white-color;
            background: $orange-peel-color;
        }
    }
}
</style>